import { useCallback, useEffect, useState } from 'preact/hooks';
import { sendPostMessage } from 'helpers/post-message.helper';
import { stateStore } from 'global/state.store';

export const useWidgetState = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleShowState = ({ data }: { data: { action?: string, state?: string } } = { data: {} }) => {
      if (data.action === 'toggled') {
        if (data.state === 'show') {
          setTimeout(() => setIsOpen(true));
          stateStore.onOpen$.next();

          // required for communication callback logic with postMessageWithNotification
          sendPostMessage({
            action: 'widgetOpened',
          });
        }

        if (data.state === 'hide') {
          setIsOpen(false);

          // required for communication callback logic with postMessageWithNotification
          sendPostMessage({
            action: 'widgetClosed',
          });
        }
      }
    };

    window.addEventListener('message', handleShowState);

    sendPostMessage({
      action: 'isWidgetOpened',
    });

    return () => window.removeEventListener('message', handleShowState);
  }, []);

  const close = useCallback(() => {
    sendPostMessage({
      action: 'on_demand_reader_stop',
    });

    sendPostMessage({
      action: 'close',
    });

    setIsOpen(false);
    stateStore.onClose$.next();
  }, [isOpen]);

  return { close, isOpen };
};
